"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _paginationItem = _interopRequireDefault(require("./pagination-item"));

var _pagination = require("./pagination.styles");

var _jsxRuntime = require("react/jsx-runtime");

const PaginationIcon = ({
  isPrev,
  disabled,
  onlyDots,
  animated,
  bordered,
  onClick,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_paginationItem.default, {
    preserveContent: true,
    value: isPrev ? '<' : '>',
    bordered: bordered,
    animated: animated,
    onlyDots: onlyDots,
    disabled: disabled,
    onClick: e => onClick && onClick(e),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_pagination.StyledPaginationIcon, {
      role: "presentation",
      focusable: "false",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "nextui-pagination-icon",
      isPrev: isPrev,
      ...props,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M15.5 19l-7-7 7-7",
        stroke: "currentColor",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })
  });
};

PaginationIcon.toString = () => '.nextui-pagination-icon';

const MemoPaginationIcon = /*#__PURE__*/_react.default.memo(PaginationIcon);

var _default = MemoPaginationIcon;
exports.default = _default;
module.exports = exports.default;